{
  "id": "campaign-053",
  "name": "Sleepy Field",
  "seed": "campaign:53",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRR........",
    "RRRR........",
    "____........",
    "..........x.",
    "..u.T..T.u..",
    "............",
    "f..fffffffff",
    "............",
    ".u........u.",
    "..e.....~...",
    ".~e~...~~~..",
    "..ffffffffff",
    "............",
    "......#...~.",
    ".x..y..y.~~~",
    "..........~.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 8,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 0
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 16
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 17
    }
  ],
  "generatorVersion": 3,
  "level": 53,
  "biome": "farm",
  "par": {
    "reel": 6150,
    "push": 5447,
    "selfPropelled": 5028,
    "tractor": 5160,
    "zeroTurn": 3462,
    "fairway": 2519
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 12
    }
  }
}
